export enum StatusPainelDeAtendimento {
  Aberto,
  Fechado,
}
